import React from 'react'
import SimplePage from '../layouts/simplePage'

const PressRelease = () => {
    return (
        <SimplePage
            title={'Press Release'}
            image={require('../assets/images/carlous-img2.jpg')}
        >
            <p>
                IATA Accredited, Active Member of Indian Association of Tour
                Operators (IATO), Travel Agent Federation of India (TAFI) &amp;
                Pacific Asia Travel Association (PATA), an ISO 9001-2015
                Certified Travel Company
            </p>
            <h3>
                Skyway is being promoted through one of the best travel
                magazines "Travel with style".
            </h3>
            <hr />
            <h4>
                Skyway finding it's space in the columns of the reputed print
                media "The Hindu".
            </h4>
            <hr />
            <h5>BEST MARKETING INNOVATION AWARD 2019 FROM IATO</h5>
            <img
                src={require('../assets/images/IATO-award-photo-2019.jpg')}
                alt=''
                style={{
                    width: '100%',
                    height: '500px',
                }}
            />
            <p>
                Photo description: Mr. S. Mahalingaiah, Director & Mr.
                Venugopal, Sr. Manager, Skyway International Travels receiving
                the Award.
            </p>
            <hr />
            <p>
                <strong>Bangaluru </strong> : 14 th September, 2019 - Skyway
                International Travels bags Best Marketing Innovation Award on
                CD/Video Category during 35 th IATO Convention held from 12-15
                September, 2019 at ITC Royal Bengal, Kolkata under theme{' '}
                <strong>
                    &nbsp;“Is Tourism Thriving? Challenges and Opportunities”.
                </strong>{' '}
                Skyway is achieving this award consecutively last 3 years.
            </p>
            <p>
                Mr. S. Mahalingaiah, Director & Mr. Venugopal, Sr. Manager from
                Skyway International Travels received the award. from Mr. Rajiv
                Mehra, Convention Chairman, IATO & Sr. Vice President, Mr. E.M.
                Najeeb & Mr. Rajesh Mudgill, Hony. Secretary on the occasion.
            </p>
            <p>
                Amidst mega fanfare, the 35 th annual convention of the Indian
                Association of Tour Operators (IATO) was inaugurated at the
                Biswa Bangla Convention Centre in Kolkata. A high-level
                government delegation including <strong>Goutam Deb</strong>,
                Tourism Minister, West Bengal,<strong> Debashis Sen</strong>,
                Chairman, HIDCO &amp; Additional Chief Secretary, Government of
                West Bengal, <strong>Jyoti Prakash Panigrahi</strong>, Minister
                for Tourism, Odia Language, Literature and Culture and{' '}
                <strong>Atri Bhattacharya</strong>, Principal Secretary Tourism,
                Government of West Bengal were present during the glittering
                opening ceremony along with the IATO leadership and many other
                stalwarts of the travel trade.
            </p>
            <p>
                IATO Convention is one of the most important events on the
                Indian tourism calendar and attracts over 1200 – 1500 delegates
                each year. There is a strong participation of decision makers
                from Ministry of Tourism, Govt. of India &amp; State
                Governments, and the private sector and also brings dignitaries
                from across the country and overseas. The Convention is the main
                gathering of stakeholders in the Tourism Industry and the common
                platform for forming strategies and policies for the coming
                year.
            </p>
            <p>
                <b>
                    Venugopal
                    <br />
                    Sr. Manager
                    <br />
                    Press Information Officer
                </b>
            </p>
            <hr />
            <h5>FKCCI KARNATAKA TOURISM AWARDS 2018</h5>

            <img
                src={require('../assets/images/fkcci-award-pic.jpg')}
                alt=''
                style={{
                    width: '100%',
                    height: '500px',
                }}
            />
            <p>
                Mysore :4 th July, 2018 - Skyway International Travels received{' '}
                <b>
                    FKCCI Karnataka Tourism Award 2018 as Best Inbound Tour
                    Operator
                </b>{' '}
                from the Hon’ble Minister for Tourism &amp; Sericulture, Mr.
                S.R. Mahesh at Sir M.V. Auditorium, Federation House, Bangalore
                on 27 th June, 2018. The Award function was Organised by
                Federation of Karnataka Chambers of Commerce and Industry
                (FKCCI) for the Second Edition of FKCCI Tourism Award 2018. Mr.
                Venugopalan Nambiar, Sr. Manager &amp; Mr. Manjunatha S.,
                Manager received the award on behalf of the company from the
                Minister.
            </p>
            <hr />
            <p>
                SKYWAY INTERNATIONAL TRAVELS BAGS “BEST MARKETING INNOVATION
                AWARD UNDER TOUR OPERATORS &amp; TRAVEL AGENTS CD/VIDEO
                CATEGORY”
            </p>
            <img
                src={require('../assets/images/inv-award-pic.jpg')}
                alt=''
                style={{
                    width: '100%',
                    height: '500px',
                }}
            />
            <p>
                Photo description: Mr. Venugopalan Nambiar, Sr. Manager, Skyway
                International Travels receiving the Award for Best Marketing
                Innovation under Tour Operators & Travel Agents under CD/Video
                Category from Mr. Satyajeet Rajan, Director General, Ministry of
                Tourism, Govt. of India during 34 th IATO Convention held at
                Visakhapatnam.
            </p>
            <hr />
            <p>
                <b>Mysore</b> : 12 th September, 2018 - Skyway International
                Travels bags Best Marketing Innovation Award on CD/Video
                Category during 34 th IATO Convention held from
                7-9&nbsp;September 2018 under theme{' '}
                <b>
                    “MISSION 20 MILLION TOURISTS – OPPORTUNITIES AND CHALLENGES”
                </b>{' '}
                at Novotel Hotel, Visakhapatnam. Mr. Venugopalan Nambiar, Sr.
                Manager from Skyway International Travels received the award
                from Mr. Satyajeet Rajan, Director General, Ministry of Tourism,
                Govt. of India during the occasion.
            </p>
            <p>
                The convention was inaugurated by Shri Mr. K.J. Alphons, Hon’ble
                Minister of Tourism, Government of India along with Minister of
                Tourism Andhra Pradesh, Ms. Bhuma Akhila Priya, Minister for
                Co-operation, Tourism and Devaswoms, Government of Kerala, Mr.
                Kadakampally Surendran, along with other dignitaries.
            </p>
            <p>
                IATO Convention is one of the most important events on the
                Indian tourism calendar and attracts over 1200 – 1500 delegates
                each year. There is a strong participation of decision makers
                from Ministry of Tourism, Govt. of India &amp; State
                Governments, and the private sector and also brings dignitaries
                from across the country and overseas. The Convention is the main
                gathering of stakeholders in the Tourism Industry and the common
                platform for forming strategies and policies for the coming
                year.
            </p>
            <p>
                <b>
                    Venugopal
                    <br />
                    Sr. Manager
                    <br />
                    Press Information Officer
                </b>
            </p>
            <hr />
            <img
                src={require('../assets/images/mountain-callling-02.jpg')}
                alt=''
            />
            <img
                src={require('../assets/images/mountain-callling-01.jpg')}
                alt=''
            />
            <h4>
                Skyway co-sponsorers the Mountain Biking Corporate Challange
            </h4>
            <img src={require('../assets/images/PR1.jpg')} alt='' />
            <h4>Ms. Poojashree Venkatesh</h4>
            <img src={require('../assets/images/PR2.jpg')} alt='' />
            <h4>Skyway AITA Tennis in News paper</h4>
            <img src={require('../assets/images/PR3.jpg')} alt='' />
            <h4>Skyway Block - Library Inauguration 29th July 2011</h4>
            <img src={require('../assets/images/PR4.jpg')} alt='' />
            <h4>Skyway Block Inagraul News in Incredible India Magzine</h4>
            <img src={require('../assets/images/PR5.jpg')} alt='' />
            <h4>Skyway Block Innagruation in Mysore</h4>
            <img src={require('../assets/images/PR6.jpg')} alt='' />
            <h4>Skyway Mysore Marathon Celebration</h4>
            <img src={require('../assets/images/PR7.jpg')} alt='' />
            <h4>Skyway Talent Series Tennis Tournament</h4>
            <img src={require('../assets/images/PR8.jpg')} alt='' />
            <h4>Skyway Tennis</h4>
            <img src={require('../assets/images/PR9.jpg')} alt='' />
        </SimplePage>
    )
}

export default PressRelease
